webpackJsonp([6],{

/***/ "/Dq+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("hEGY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66a221aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("F1xv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66a221aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Pn3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_logic_js__ = __webpack_require__("Jz6g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5682e60c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Lna9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_logic_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5682e60c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "30Dl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("LR3v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d7b6312_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("GVHp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d7b6312_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3TFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menu___ = __webpack_require__("/Dq+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_data_context_json__ = __webpack_require__("lEEI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_data_context_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_data_context_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'case-case-lobby',
  data: function data() {
    return {
      context: __WEBPACK_IMPORTED_MODULE_1__assets_data_context_json___default.a.current_context,
      lobbyBG: this.$route.params.case
    };
  },

  props: ['props'],
  beforeMount: function beforeMount() {
    this.$nextTick(function () {
      window.scrollTo(0, 0);
    });
  },
  mounted: function mounted() {
    this.util.addBodyClass('dark-bg');
  },

  methods: {
    moveOnCase: function moveOnCase() {
      this.$bus.$emit('LOADER.SHOW');
      this.$router.push({ path: '/' + this.$route.params.case, props: { case_context: this.context } });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.util.removeBodyClass('dark-bg');
  },

  components: {
    'menu-co': __WEBPACK_IMPORTED_MODULE_0__components_menu___["a" /* default */]
  }
});

/***/ }),

/***/ "5XNs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BaSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("3TFv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5675449a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("UuDu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5675449a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E3k3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EOym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video-player',
  data: function data() {
    return {
      options: {},
      playerReady: false,
      styleElement: {},
      fluidStatus: true
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      window.addEventListener('resize', this.onWidthChange);
    });

    var $self = this;
    $self.$bus.$on('VIDEO.PLAYVIDEO', function () {
      if ($self.playerReady) {
        $self.$refs.player.play();
      }
    });
  },

  props: {
    videoID: {
      type: String,
      required: true
    },
    inlineStyle: {
      type: Object,
      default: null
    },
    isFluid: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // Needed to set the video dynamic width on first load
    getWidth: function getWidth() {
      return document.documentElement.clientWidth;
    },
    getStyles: function getStyles() {
      if (this.inlineStyle !== undefined) {
        if (this.inlineStyle.width !== undefined || this.inlineStyle.maxWidth !== undefined) {
          this.styleElement = this.util.jsonCopyObject(this.inlineStyle);
        }
        return this.styleElement;
      }
      return '';
    }
  },
  watch: {
    fluidStatus: function fluidStatus() {
      this.fluidStatus = this.getFluid();
    }
  },
  methods: {
    onWidthChange: function onWidthChange() {
      this.$nextTick(function () {
        this.fluidStatus = this.getFluid();
        this.$refs.player.player.element.width = document.documentElement.clientWidth;
      });
    },
    getFluid: function getFluid() {
      if (this.isFluid && (this.styleElement.width !== undefined || this.styleElement.maxWidth !== undefined)) {
        return parseInt(this.styleElement.width) > document.documentElement.clientWidth || parseInt(this.styleElement.maxWidth) > document.documentElement.clientWidth;
      }
      return false;
    },
    onReady: function onReady() {
      this.$bus.$emit('VIDEO.LOADED');
      this.playerReady = true;
      this.$refs.player.player.element.width = document.documentElement.clientWidth;
      this.fluidStatus = this.getFluid();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onWidthChange);
  }
});

/***/ }),

/***/ "F1xv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-wrapper"},[_c('div',{staticClass:"sm-md"}),_vm._v(" "),_c('div',{staticClass:"menu-bar"},[_c('div',{staticClass:"back-wrapper"},[_c('router-link',{attrs:{"to":{ path: '/' }}},[_c('div',{staticClass:"titel-menu"})])],1),_vm._v(" "),(_vm.showMenu)?_c('div',{staticClass:"burger-wrapper"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMenu),expression:"showMenu"},{name:"touch",rawName:"v-touch:tap",value:(_vm.toggleMenu),expression:"toggleMenu",arg:"tap"}],class:['burger-menu', {'open': _vm.menuOpened}]},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[(_vm.menuOpened)?_c('div',{staticClass:"bm-wrapper"},_vm._l((_vm.menuCleaned),function(menu){return _c('div',{class:['bm-option', {'selected': (_vm.currentPageName === menu.name)}]},[((menu.ref === '/lobby'))?_c('router-link',{staticClass:"router-link-active",attrs:{"to":{ path: (menu.ref + _vm.extraPath)}}},[_c('div',{staticClass:"bm-btn-wrapper"},[_c('h3',[_vm._v(_vm._s(_vm.$lang.menuoptions[menu.name]))])])]):_c('router-link',{staticClass:"router-link-active",attrs:{"to":{ path: menu.ref}}},[_c('div',{staticClass:"bm-btn-wrapper"},[_c('h3',[_vm._v(_vm._s(_vm.$lang.menuoptions[menu.name]))])])])],1)})):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FA5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_data_context_json__ = __webpack_require__("lEEI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_data_context_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_data_context_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'menu-option',
  data: function data() {
    return {
      iconName: this.values.icon,
      hasCheck: false,
      dataContext: __WEBPACK_IMPORTED_MODULE_0__assets_data_context_json___default.a
    };
  },

  computed: {
    getIconClass: function getIconClass() {
      return this.iconName;
    },
    hasContext: function hasContext() {
      return this.values.context !== undefined && this.values.context !== '';
    }
  },
  watch: {
    iconName: function iconName() {
      this.iconName = this.values.icon;
    }
  },
  beforeMount: function beforeMount() {
    this.hasCheck = this.values.checked !== undefined;
  },

  props: {
    values: {
      type: Object,
      required: true,
      icon: {
        type: String,
        default: ''
      }
    },
    context: {
      type: String,
      default: ''
    },
    isbutton: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    categoryItemClicked: function categoryItemClicked() {
      if (this.values.context !== undefined && this.values.context !== '') {
        this.store.setItem(this.dataContext.current_context, this.values.context);
        if (!this.store.getItemOrFalse(this.dataContext.current_progress)) {
          var obj = {};
          for (var i = 0; i < this.dataContext.categories.length; i++) {
            obj[this.dataContext.categories[i].cat] = [];
          }
          this.store.createIfNotExisting(this.dataContext.current_progress, obj);
        }
      }
      this.$bus.$emit('MENU-OPTION-CLICKED', { context: this.values.context });
    }
  }
});

/***/ }),

/***/ "GVHp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper p-done center-md"},[_c('menu-co'),_vm._v(" "),_c('div',{staticClass:"pure-g halt-lg padding-md lobby-boxes"},[_c('div',{staticClass:"lobby-content smaller pure-u-1-1"},[_c('h2',{staticClass:"icon i-clover-blue"},[_vm._v(_vm._s(_vm.$lang.done.header))]),_vm._v(" "),_c('div',{staticClass:"chunk-style top-margin",domProps:{"innerHTML":_vm._s(_vm.$lang.done.text)}}),_vm._v(" "),_c('a',{staticClass:"btn green",attrs:{"href":""}},[_vm._v(_vm._s(_vm.$lang.done.button))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gpb2":
/***/ (function(module, exports) {

module.exports = {"videoID":"240698733","caselists":{"transport":["case1","case2","case3","case4","case5"],"other":["case1","case4","case5"]},"home":{"options":[{"opt1":{"context":"transport","args":{"cases":"cases_transport"}}},{"opt2":{"context":"other","args":{"cases":"cases_other"}}}]},"cases":{"case1":{"twoQuestions":"N","hasinfo":"N","qu":{"qu1":{"correct":"1"}}},"case2":{"twoQuestions":"N","hasinfo":"N","qu":{"qu1":{"correct":"1"}}},"case3":{"twoQuestions":"N","hasinfo":"N","qu":{"qu1":{"correct":"3"}}},"case4":{"twoQuestions":"N","hasinfo":"N","qu":{"qu1":{"correct":"3"}}},"case5":{"twoQuestions":"N","hasinfo":"N","qu":{"qu1":{"correct":"3"}}}}}

/***/ }),

/***/ "HJxK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_data_staticdata_json__ = __webpack_require__("Gpb2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_data_staticdata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_data_staticdata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_menu___ = __webpack_require__("/Dq+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_menu_options___ = __webpack_require__("rhSk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_data_context_json__ = __webpack_require__("lEEI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_data_context_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_data_context_json__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'all-progress',
  data: function data() {
    return {
      showMenu: true,
      menuOpened: false,
      menuBuild: false,
      context: '',
      options1: {},
      options2: {},
      halfCasesLength: 0,
      halfCount: 0,
      dataOptions: __WEBPACK_IMPORTED_MODULE_1__assets_data_staticdata_json___default.a,
      dataContext: __WEBPACK_IMPORTED_MODULE_4__assets_data_context_json___default.a
    };
  },
  beforeMount: function beforeMount() {
    this.context = this.store.getItemOrDefault(this.dataContext.current_context, 'transport');
    this.buildMenu();
  },

  methods: {
    buildMenu: function buildMenu(override) {
      if (!this.menuBuild && (override === undefined || !override)) {
        var count = 1;
        var progress = this.store.getItemByCategory(this.dataContext.current_progress, this.context);
        var progressCopy = this.util.copyArrayByField(progress, 'name');
        this.halfCasesLength = parseInt(this.dataOptions.caselists[this.context].length / 2);
        this.halfCount = 0;
        this.options1 = {};
        this.options2 = {};

        for (var i = 0; i < this.$lang.menu.options.length; i++) {
          var option = this.$lang.menu.options[i];
          var objectKey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(option);
          if (option.hasOwnProperty(objectKey)) {
            // Checks so this user has this menu option
            var shouldHaveOption = this.util.arrayContainsValue(option[objectKey].caseref, this.dataOptions.caselists[this.context]);
            if (shouldHaveOption) {
              if (this.halfCount <= this.halfCasesLength) {
                this.options1['opt' + count] = option[objectKey];
                this.options1['opt' + count].checked = this.util.arrayContainsValue(option[objectKey].caseref, progressCopy);
              } else {
                this.options2['opt' + count] = option[objectKey];
                this.options2['opt' + count].checked = this.util.arrayContainsValue(option[objectKey].caseref, progressCopy);
              }
              this.halfCount++;
            }
            count++;
          }
        }
        this.menuBuild = true;
      }
    },
    moveToCurrentCategory: function moveToCurrentCategory() {
      var catCases = this.dataOptions.caselists[this.context];
      var progress = this.store.getItem(this.dataContext.current_progress)[this.context];
      var moveTo = this.util.getFirstQuestionForCategoryNotAnswered(catCases, progress);
      if (!moveTo) {
        this.$router.push({ path: '/case-lobby/case1' });
      } else {
        this.$router.push({ path: '/case-lobby/' + moveTo });
      }
    }
  },
  components: {
    'menu-co': __WEBPACK_IMPORTED_MODULE_2__components_menu___["a" /* default */],
    'menu-option': __WEBPACK_IMPORTED_MODULE_3__components_menu_options___["a" /* default */]
  }
});

/***/ }),

/***/ "JaNw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view')],1),_vm._v(" "),_c('transition',{attrs:{"name":"page-loader"}},[(_vm.showLoader)?_c('div',{staticClass:"page-loader-wrapper"},[_c('div',{staticClass:"page-loader-bg"}),_vm._v(" "),_c('div',{staticClass:"page-loader-icon"},[_c('p',[_vm._v(_vm._s(_vm.$lang.loader))]),_c('span')])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jz6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_video_player___ = __webpack_require__("laZx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_options___ = __webpack_require__("rhSk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_menu___ = __webpack_require__("/Dq+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_context_json__ = __webpack_require__("lEEI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_context_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_data_context_json__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      vimeoVideoID: this.$lang.videoID !== undefined ? this.$lang.videoID : '240698733',
      section2: {
        options: {
          autoplay: 0,
          autopause: 0
        }
      },
      removeLoader: false,
      hasLoadedVideo: false,
      context: __WEBPACK_IMPORTED_MODULE_3__assets_data_context_json___default.a
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.scrollTo(0, 0);
    });

    var self = this;
    this.$bus.$on('LANGUAGE.CHANGE', function () {
      self.buildOptions();
    });

    this.$bus.$on('VIDEO.LOADED', function () {
      _this.hasLoadedVideo = true;
    });

    this.util.addBodyClass('blue-bg');
  },
  beforeDestroy: function beforeDestroy() {
    this.util.removeBodyClass('blue-bg');
  },

  methods: {
    clickToPlayVideo: function clickToPlayVideo() {
      if (this.hasLoadedVideo) {
        this.removeLoader = true;
        this.$bus.$emit('VIDEO.PLAYVIDEO');
      }
    },
    changeLang: function changeLang(lang) {
      if (this.$lang.currentLang === undefined || this.$lang.currentLang !== lang) {
        this.$setLang(lang);
        this.$bus.$emit('LANGUAGE.CHANGE');
      }
    }
  },
  components: {
    'menu-co': __WEBPACK_IMPORTED_MODULE_2__components_menu___["a" /* default */],
    'video-player': __WEBPACK_IMPORTED_MODULE_0__components_video_player___["a" /* default */],
    'menu-option': __WEBPACK_IMPORTED_MODULE_1__components_menu_options___["a" /* default */]
  }
});

/***/ }),

/***/ "LR3v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menu___ = __webpack_require__("/Dq+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_data_staticdata_json__ = __webpack_require__("Gpb2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_data_staticdata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_data_staticdata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_context_json__ = __webpack_require__("lEEI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_context_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_data_context_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'case-done',
  data: function data() {
    return {
      context: '',
      dataOption: __WEBPACK_IMPORTED_MODULE_1__assets_data_staticdata_json___default.a,
      dataContext: __WEBPACK_IMPORTED_MODULE_2__assets_data_context_json___default.a,
      correctDone: ''
    };
  },

  props: ['props'],
  beforeMount: function beforeMount() {
    this.context = this.store.getItem(this.dataContext.current_context);
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      window.scrollTo(0, 0);
    });
    this.util.addBodyClass('beige-bg');
  },
  beforeDestroy: function beforeDestroy() {
    this.util.removeBodyClass('beige-bg');
  },

  components: {
    'menu-co': __WEBPACK_IMPORTED_MODULE_0__components_menu___["a" /* default */]
  }
});

/***/ }),

/***/ "Lna9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper p-home"},[_c('menu-co'),_vm._v(" "),_c('h1',{staticClass:"real-h1"},[_vm._v(_vm._s(_vm.$lang.home.title))]),_vm._v(" "),_c('div',{staticClass:"welcome-block"},[_c('div',{staticClass:"pure-g pure-reverse-md halt-lg "},[_c('div',{staticClass:"movie-block pure-u-1-1 pure-u-md-1-2"},[_c('div',{directives:[{name:"touch",rawName:"v-touch:tap",value:(_vm.clickToPlayVideo),expression:"clickToPlayVideo",arg:"tap"}],class:['video-loader', {'show': !_vm.removeLoader}, {'remove': _vm.removeLoader}]},[_c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"loader-text"},[_c('h3',[_vm._v(_vm._s(_vm.$lang.home.video))])]),_vm._v(" "),_c('div',{staticClass:"loader-icon i-load-video"})])]),_vm._v(" "),_c('video-player',{attrs:{"videoID":_vm.vimeoVideoID,"inlineStyle":{maxWidth: '768px'}}})],1),_vm._v(" "),_c('div',{class:['text-block', 'pure-u-1-1', 'pure-u-md-1-2', {'loaderShowing': !_vm.removeLoader}]},[_c('div',{staticClass:"text-wrapper fw-fix"},[_c('h2',{staticClass:"fake-h1"},[_vm._v(_vm._s(_vm.$lang.home.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$lang.home.sec1.p1))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$lang.home.sec1.p2))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$lang.home.sec1.p3))])])])])]),_vm._v(" "),_c('div',{staticClass:"h-selection-block"},[_c('div',{staticClass:"h-question-wrapper h-md-c"},[_c('h4',[_vm._v(_vm._s(_vm.$lang.home.question))])]),_vm._v(" "),_c('div',{staticClass:"h-q-btn-box"},[_c('div',{staticClass:"h-hidden-md"},[_c('h4',[_vm._v(_vm._s(_vm.$lang.home.qu))])]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$lang.home.do_you))]),_vm._v(" "),_c('div',{staticClass:"h-q-btn-wrapper pure-g"},[_c('div',{staticClass:"h-btn-holder pure-u-1-2"},[_c('router-link',{staticClass:"router-link-active btn white",attrs:{"to":{ path: '/lobby/' + _vm.$lang.cat1 }}},[_vm._v(_vm._s(_vm.$lang.home.yes))])],1),_vm._v(" "),_c('div',{staticClass:"h-btn-holder pure-u-1-2"},[_c('router-link',{staticClass:"router-link-active btn white",attrs:{"to":{ path: '/lobby/' + _vm.$lang.cat2 }}},[_vm._v(_vm._s(_vm.$lang.home.no))])],1)])])]),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-logo-wrapper"},[_c('div',{staticClass:"icon index-icon"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5328a2b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("JaNw");
function injectStyle (ssrContext) {
  __webpack_require__("E3k3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5328a2b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_object_assign_auto__ = __webpack_require__("kZDd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_object_assign_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_object_assign_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_vimeo_player__ = __webpack_require__("SY33");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lang__ = __webpack_require__("qyRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_lang__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_touch_events__ = __webpack_require__("ufW0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_touch_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_touch_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_scrollto__ = __webpack_require__("bm7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_vue_util__ = __webpack_require__("Wtx3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_vue_store__ = __webpack_require__("kokZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_text_no_json__ = __webpack_require__("rSOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_text_no_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_text_no_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_data_context_json__ = __webpack_require__("lEEI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_data_context_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_data_context_json__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill'









/** Custom code **/



/** Language files **/
// import langSv from './assets/text/sv.json'
// import langFi from './assets/text/fi.json'
// import langDk from './assets/text/dk.json'

// import langEn from './assets/text/en.json'



var locales = {
  // 'sv': langSv
  // 'fi': langFi
  // 'dk': langDk
  'no': __WEBPACK_IMPORTED_MODULE_10__assets_text_no_json___default.a
  // 'en': langEn


  /** Communications Bus (Change this to vuex if needed!!!) **/
};__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$bus = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]();

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_lang___default.a, { lang: 'no', locales: locales });
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_es6_object_assign_auto___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__plugins_vue_util__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9__plugins_vue_store__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_vimeo_player__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue2_touch_events___default.a);

var nav = typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
if (nav === undefined) {
  nav = true;
} else {
  nav = !nav;
}

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_scrollto___default.a, {
  container: '#scrollContainer',
  duration: 500,
  easing: 'ease-out',
  offset: 0,
  // cancelable: false, // If false, there can be some flickering (on desktop devices) sometimes
  cancelable: nav,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  data: function data() {
    return {
      context: __WEBPACK_IMPORTED_MODULE_11__assets_data_context_json___default.a
    };
  },
  beforeMount: function beforeMount() {
    this.util.init();
  },

  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "QUQt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menu___ = __webpack_require__("/Dq+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_data_context_json__ = __webpack_require__("lEEI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_data_context_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_data_context_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_staticdata_json__ = __webpack_require__("Gpb2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_staticdata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_data_staticdata_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'case-lobby',
  data: function data() {
    return {
      category: '',
      dataContext: __WEBPACK_IMPORTED_MODULE_1__assets_data_context_json___default.a,
      dataOptions: __WEBPACK_IMPORTED_MODULE_2__assets_data_staticdata_json___default.a
    };
  },

  props: ['props'],
  beforeMount: function beforeMount() {
    this.category = this.$route.params.cat === this.dataContext.categories[0].cat || this.$route.params.cat === this.dataContext.categories[1].cat ? this.$route.params.cat : this.dataContext.categories[0].cat;

    this.store.setItem(this.dataContext.current_context, this.category);
    if (!this.store.getItemOrFalse(this.dataContext.current_progress)) {
      var obj = {};
      obj[this.dataContext.categories[0].cat] = [];
      obj[this.dataContext.categories[1].cat] = [];
      this.store.createIfNotExisting(this.dataContext.current_progress, obj);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      window.scrollTo(0, 0);
    });
  },

  methods: {
    moveOn: function moveOn() {
      this.$router.push({ path: '/case-progress' });
      // TODO: If theuser has done all questions for this category, then redirect to checklist
      //        let catCases = this.dataOptions.caselists[this.category]
      //        let progress = this.store.getItem(this.dataContext.current_progress)[this.category]
      //        let moveTo = this.util.getFirstQuestionForCategoryNotAnswered(catCases, progress)
      //        if (!moveTo) {
      //          this.$router.push({ path: `/checklist` })
      //        } else {
      //          this.$router.push({ path: `/case-progress` })
      //        }
    },
    categoryItemClicked: function categoryItemClicked(cat) {
      this.store.setItem(this.context.current_context, this.context.categories[cat].cat);
      if (!this.store.getItemOrFalse(this.context.current_progress)) {
        var obj = {};
        obj[this.context.categories[0].cat] = [];
        obj[this.context.categories[1].cat] = [];
        this.store.createIfNotExisting(this.context.current_progress, obj);
      }
    }
  },
  components: {
    'menu-co': __WEBPACK_IMPORTED_MODULE_0__components_menu___["a" /* default */]
  }
});

/***/ }),

/***/ "RNo4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("QUQt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c0c19c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("T/Sc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c0c19c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T/Sc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"pageTop",staticClass:"page-wrapper p-lobby center-md"},[_c('menu-co'),_vm._v(" "),_c('div',{staticClass:"pure-g halt-lg padding-md lobby-boxes"},[_c('div',{staticClass:"lobby-content pure-u-1-1"},[_c('h2',{class:['icon', 'icon-' + _vm.category]},[_vm._v(_vm._s(_vm.$lang.lobby[_vm.category]))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$lang.lobby.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$lang.lobby.text))]),_vm._v(" "),_c('div',{directives:[{name:"touch",rawName:"v-touch:tap",value:(_vm.moveOn),expression:"moveOn",arg:"tap"}],staticClass:"btn green"},[_vm._v(_vm._s(_vm.$lang.lobby.button))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UuDu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['page-wrapper', 'p-case-lobby', ('bg-' + _vm.lobbyBG), 'center-md']},[_c('menu-co'),_vm._v(" "),_c('div',{staticClass:"lobby-type"},[_c('div',{class:['lobby-icon', _vm.$lang[_vm.$route.params.case].icon]}),_vm._v(" "),_c('h3',{staticClass:"case-name"},[_vm._v(_vm._s(_vm.$lang[_vm.$route.params.case].lobby_header))]),_vm._v(" "),_c('p',{staticClass:"case-title"},[_vm._v(_vm._s(_vm.$lang[_vm.$route.params.case].lobby_desc))]),_vm._v(" "),_c('div',{directives:[{name:"touch",rawName:"v-touch:tap",value:(_vm.moveOnCase),expression:"moveOnCase",arg:"tap"}],staticClass:"btn green dark-hover"},[_vm._v(_vm._s(_vm.$lang.case_lobby.button))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wtx3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__("aFK5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");




var utils = {
  install: function install(V) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.util = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
      data: function data() {
        return {
          transitionEndEvent: null,
          animationEndEvent: null
        };
      },

      methods: {
        whichTransitionEvent: function whichTransitionEvent() {
          var t = void 0;
          var el = document.createElement('fakeelement');

          var transitions = {
            'transition': 'transitionend',
            'OTransition': 'oTransitionEnd',
            'MozTransition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd'
          };

          for (t in transitions) {
            if (el.style[t] !== undefined) {
              return transitions[t];
            }
          }
        },
        whichAnimationEvent: function whichAnimationEvent() {
          var t = void 0;
          var el = document.createElement('fakeelement');

          var animations = {
            'animation': 'animationend',
            'OAnimation': 'oAnimationEnd',
            'MozAnimation': 'animationend',
            'WebkitAnimation': 'webkitAnimationEnd'
          };

          for (t in animations) {
            if (el.style[t] !== undefined) {
              return animations[t];
            }
          }
        },
        init: function init() {
          this.transitionEndEvent = this.whichTransitionEvent();
          this.animationEndEvent = this.whichAnimationEvent();
        },
        getFirstQuestionForCategoryNotAnswered: function getFirstQuestionForCategoryNotAnswered(catCases, progress) {
          // Not started the question
          if (progress.length === 0) {
            return catCases[0];
          }

          // Have done all question
          if (progress.length === catCases.length) {
            return false;
          }

          // Need to copy the array as the setup was not done for this initially
          var tmpArray = this.copyArrayByField(progress, 'name');
          // for (let y = 0; y < progress.length; y++) {
          //   tmpArray.push(progress[y].name)
          // }

          for (var i = 0; i < catCases.length; i++) {
            if (!this.arrayContainsValue(catCases[i], tmpArray)) {
              return catCases[i];
            }
          }
          return false;
        },
        copyArrayByField: function copyArrayByField(copyArr, field) {
          var tmpArray = [];
          for (var y = 0; y < copyArr.length; y++) {
            tmpArray.push(copyArr[y][field]);
          }
          return tmpArray;
        },
        getCorrectCount: function getCorrectCount(arr, length) {
          var correct = 0;
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].aicd) {
              correct++;
            }
          }
          return correct + '/' + length;
        },


        /**
         * Replaces content of string with placeholder/s
         * Placeholder string should have the format of "blabla {0} blabla {1} ..."
         * {index} is replaced in order by the replacement (which can be string or array)
         *
         * @param {string} placeholderString - string that contains placeholders
         * @param {*} replacement - Can be a string or array of strings
         * @returns {*} - returns the string with the placeholders replaced, or false if there was a problem
         */
        replacePlaceholderWithString: function replacePlaceholderWithString(placeholderString, replacement) {
          var repl = null;
          if (replacement instanceof Array) {
            repl = replacement;
          } else {
            repl = [replacement];
          }

          if (typeof placeholderString === 'string' && repl instanceof Array) {
            return placeholderString.replace(/({\d})/g, function (i) {
              return repl[i.replace(/{/, '').replace(/}/, '')];
            });
          } else if (typeof placeholderString === 'string' && repl instanceof Object) {
            for (var key in repl) {
              return placeholderString.replace(/({([^}]+)})/g, function (i) {
                var key = i.replace(/{/, '').replace(/}/, '');
                if (!repl[key]) {
                  return i;
                }

                return repl[key];
              });
            }
          } else {
            return false;
          }
        },


        indexOfwithPollyfill: function indexOfwithPollyfill(searchElement, array, fromIndex) {
          if (!Array.prototype.indexOf) {
            var k = void 0;
            if (array == null) {
              throw new TypeError('"this" is null or not defined');
            }
            var O = Object(array);
            var len = O.length >>> 0;
            if (len === 0) {
              return -1;
            }
            var n = +fromIndex || 0;
            if (Math.abs(n) === Infinity) {
              n = 0;
            }
            if (n >= len) {
              return -1;
            }
            k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
            while (k < len) {
              if (k in O && O[k] === searchElement) {
                return k;
              }
              k++;
            }
            return -1;
          } else {
            return array.indexOf(searchElement) > -1;
          }
        },

        /**
         * Compares two objects for equality
         * @param {object} objA - first object
         * @param {object} objB - second object
         * @returns {boolean}
         */
        objectsAreEqual: function objectsAreEqual(objA, objB) {
          // Create arrays of property names
          var aProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default()(objA);
          var bProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default()(objB);

          // Some browser creates a __ob__ element at the end of the property name array
          if (bProps[bProps.length - 1] === '__ob__') {
            bProps.splice(bProps.length - 1, 1);
          }

          // If number of properties is different,
          // objects are not equivalent
          if (aProps.length !== bProps.length) {
            return false;
          }

          for (var i = 0; i < aProps.length; i++) {
            var propName = aProps[i];

            // If values of same property are not equal,
            // objects are not equivalent
            if (objA[propName] !== objB[propName]) {
              return false;
            }
          }

          // If we made it this far, objects
          // are considered equivalent
          return true;
        },
        jsonCopyObject: function jsonCopyObject(obj) {
          if (JSON) {
            return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
          }
          return false;
        },
        objectIsInArray: function objectIsInArray(obj, objArray) {
          for (var i = 0; i < objArray.length; i++) {
            if (this.objectsAreEqual(obj, objArray[i])) {
              return true;
            }
          }
          return false;
        },
        addBodyClass: function addBodyClass(className) {
          var classes = document.getElementsByTagName('body')[0].className;
          if (classes !== '') {
            var parts = classes.split(' ');
            for (var i = 0; i < parts.length; i++) {
              if (parts[i] === className.trim()) {
                return false;
              }
            }
          }
          document.getElementsByTagName('body')[0].className += className + ' ';
        },
        getBgUrl: function getBgUrl(el) {
          var bg = '';
          if (el.currentStyle) {
            // IE
            bg = el.currentStyle.backgroundImage;
          } else if (document.defaultView && document.defaultView.getComputedStyle) {
            // Firefox
            bg = document.defaultView.getComputedStyle(el, '').backgroundImage;
          } else {
            // try and get inline style
            bg = el.style.backgroundImage;
          }
          return bg.replace(/url\(['"]?(.*?)['"]?\)/i, '$1');
        },
        removeBodyClass: function removeBodyClass(className) {
          var classes = document.getElementsByTagName('body')[0].className.trim();
          if (classes !== '') {
            var parts = classes.split(' ');
            var remainder = '';
            for (var i = 0; i < parts.length; i++) {
              if (parts[i] !== className) {
                remainder += parts[i] + ' ';
              }
            }
            document.getElementsByTagName('body')[0].className = remainder;
          }
        },
        scrollTop: function scrollTop(el) {
          if (el === undefined) {
            window.scrollTo(0, 0);
          } else {
            el.scrollTo(0, 0);
          }
        },
        arrayContainsValue: function arrayContainsValue(value, array, fromIndex) {
          var from = fromIndex !== undefined ? fromIndex : 0;
          return this.indexOfwithPollyfill(value, array, from);
        },
        arrayContainsObjectValue: function arrayContainsObjectValue(value, array) {
          for (var i = 0; i < array.length; i++) {
            if (array[i] === value) {
              return array[i];
            }
          }
          return false;
        }
      }
    });
  }
};

if (window !== undefined && window.Vue) {
  window.Vue.use(utils);
}

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),

/***/ "XFS4":
/***/ (function(module, exports) {

module.exports = {"menuoptions":[{"name":"mo1","ref":"/home"},{"name":"mo2","ref":"/lobby"},{"name":"mo3","ref":"/case-progress"},{"name":"mo4","ref":"/done"}]}

/***/ }),

/***/ "XyvV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['video-wrapper', 'js-video'],style:(_vm.getStyles)},[_c('vimeo-player',{ref:"player",attrs:{"video-id":_vm.videoID,"player-width":_vm.getWidth},on:{"ready":_vm.onReady}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_content_home___ = __webpack_require__("1Pn3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_content_lobby___ = __webpack_require__("RNo4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_content_case_lobby___ = __webpack_require__("BaSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_content_done___ = __webpack_require__("30Dl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_content_case_progress___ = __webpack_require__("rY+s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_assets_data_context_json__ = __webpack_require__("lEEI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_assets_data_context_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__src_assets_data_context_json__);



// PAGES








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var getItemOrDefault = function getItemOrDefault(key, defaultValue) {
  if (localStorage.getItem(key) === undefined || localStorage.getItem(key) === null) {
    return defaultValue;
  }
  return JSON.parse(localStorage.getItem(key));
};

// If there is no context variable, then redirect to home
var noDirectAccess = function noDirectAccess(to, from, next) {
  var hasContext = getItemOrDefault(__WEBPACK_IMPORTED_MODULE_7__src_assets_data_context_json___default.a.current_context, null);
  if (hasContext === null) {
    next({ path: '/' });
  } else {
    next();
  }
};

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_content_home___["a" /* default */]
  }, {
    path: '/lobby/:cat',
    name: 'Lobby',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_3__components_content_lobby___["a" /* default */]
  }, {
    path: '/case-lobby/:case',
    name: 'CaseLobby',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_4__components_content_case_lobby___["a" /* default */]
  }, {
    path: '/case-progress',
    name: 'Progress',
    component: __WEBPACK_IMPORTED_MODULE_6__components_content_case_progress___["a" /* default */],
    beforeEnter: noDirectAccess
  }, {
    path: '/case1',
    name: 'Case1',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "9TxD"));
    },
    beforeEnter: noDirectAccess
  }, {
    path: '/case2',
    name: 'Case2',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "52Id"));
    },
    beforeEnter: noDirectAccess
  }, {
    path: '/case3',
    name: 'Case3',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "tJ3Q"));
    },
    beforeEnter: noDirectAccess
  }, {
    path: '/case4',
    name: 'Case4',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "qudQ"));
    },
    beforeEnter: noDirectAccess
  }, {
    path: '/case5',
    name: 'Case5',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "0S1S"));
    },
    beforeEnter: noDirectAccess
  }, {
    path: '/done',
    name: 'Done',
    component: __WEBPACK_IMPORTED_MODULE_5__components_content_done___["a" /* default */],
    beforeEnter: noDirectAccess
  }, {
    path: '/*',
    redirect: { name: 'Home' },
    name: 'Default',
    component: __WEBPACK_IMPORTED_MODULE_2__components_content_home___["a" /* default */]
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Zgsm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-menu"},[_c('menu-co'),_vm._v(" "),_c('div',{staticClass:"page-menu-wrapper"},[_c('div',{staticClass:"menu-new-wrapper"},[_c('h2',[_vm._v(_vm._s(_vm.$lang.menu.menu_titel))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$lang.menu.ingress))])]),_vm._v(" "),_c('div',{staticClass:"side-menu"},[_c('div',{staticClass:"sidemenu-box"},[_c('div',{staticClass:"pure-g button-wrapper set-lg"},[_c('div',{staticClass:"pure-u-1-1 pure-u-md-1-2"},[_c('div',{staticClass:"pure-g"},_vm._l((_vm.options1),function(option,index){return _c('menu-option',{key:index,attrs:{"values":option,"isbutton":false}})}))]),_vm._v(" "),_c('div',{staticClass:"pure-u-1-1 pure-u-md-1-2"},[_c('div',{staticClass:"pure-g"},_vm._l((_vm.options2),function(option,index){return _c('menu-option',{key:index,attrs:{"values":option,"isbutton":false}})}))])])])]),_vm._v(" "),_c('div',{staticClass:"menu-new-wrapper"},[_c('div',{directives:[{name:"touch",rawName:"v-touch:tap",value:(_vm.moveToCurrentCategory),expression:"moveToCurrentCategory",arg:"tap"}],staticClass:"btn green"},[_vm._v(_vm._s(_vm.$lang.menu.btn_move_on))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hEGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menu_options___ = __webpack_require__("rhSk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_data_context_json__ = __webpack_require__("lEEI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_data_context_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_data_context_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_menuoptions_json__ = __webpack_require__("XFS4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_menuoptions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_data_menuoptions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_staticdata_json__ = __webpack_require__("Gpb2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_staticdata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_data_staticdata_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'menu-co',
  data: function data() {
    return {
      showMenu: true,
      menuOpened: false,
      menuoptions: __WEBPACK_IMPORTED_MODULE_2__assets_data_menuoptions_json___default.a.menuoptions,
      options: __WEBPACK_IMPORTED_MODULE_3__assets_data_staticdata_json___default.a,
      currentPageName: '',
      context: __WEBPACK_IMPORTED_MODULE_1__assets_data_context_json___default.a,
      showDone: false,
      extraPath: ''
    };
  },

  props: {
    text: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  beforeMount: function beforeMount() {
    var path = this.$route.path;

    if (path.indexOf('/lobby/') > -1) {
      path = path.split('/')[1];
    }

    this.extraPath = '/' + this.store.getItemOrDefault(this.context.current_context, 'transport');

    switch (path) {
      case '/home':
        this.currentPageName = 'mo1';
        break;
      case 'lobby':
        this.currentPageName = 'mo2';
        break;
      case '/case-progress':
        this.currentPageName = 'mo3';
        break;
      case '/done':
        this.currentPageName = 'mo4';
        break;
    }

    if (this.showMenu) {
      this.showDone = this.allCasesDone();
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$route.path === '/') {
      this.showMenu = false;
    }
    this.$bus.$on('MENU-OPTION-CLICKED', function () {
      if (_this.menuOpened) {
        _this.menuOpened = false;
      }
    });
  },

  computed: {
    getPage: function getPage() {
      return this.$route.name;
    },

    menuCleaned: function menuCleaned() {
      var self = this;
      return this.menuoptions.filter(function (obj) {
        if (obj.ref !== '/done' || obj.ref === '/done' && self.showDone) {
          return obj;
        }
      });
    }
  },
  methods: {
    changeLang: function changeLang(lang) {
      var self = this;
      return function () {
        self.onChangeLang(lang);
      };
    },
    onChangeLang: function onChangeLang(lang) {
      // TODO: Remove Later
      if (this.$lang.currentLang === undefined || this.$lang.currentLang !== lang) {
        this.$setLang(lang);
      }
    },
    allCasesDone: function allCasesDone() {
      var currCon = this.store.getItemOrFalse(this.context.current_context);
      if (currCon) {
        var doneLength = this.options.caselists[currCon].length;
        var prog = this.store.getItem(this.context.current_progress);
        var progLength = prog[currCon].length;

        return progLength >= doneLength;
      }
      return false;
    },
    toggleMenu: function toggleMenu() {
      this.menuOpened = !this.menuOpened;
    }
  },
  components: {
    'menu-option': __WEBPACK_IMPORTED_MODULE_0__components_menu_options___["a" /* default */]
  }
});

/***/ }),

/***/ "kokZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");



var store = {
  install: function install(V) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.store = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
      data: function data() {
        return {};
      },

      methods: {
        // save an item to localStorage
        setItem: function setItem(key, value) {
          return localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
        },


        // retrieve an item from localStorage
        getItem: function getItem(key) {
          if (localStorage.getItem(key) === undefined || localStorage.getItem(key) === null) {
            return {};
          }
          return JSON.parse(localStorage.getItem(key));
        },
        getItemByCategory: function getItemByCategory(key, name) {
          if (localStorage.getItem(key) === undefined || localStorage.getItem(key) === null) {
            return false;
          } else {
            var res = JSON.parse(localStorage.getItem(key));
            return res[name] !== undefined ? res[name] : [];
          }
        },
        getItemOrFalse: function getItemOrFalse(key) {
          if (localStorage.getItem(key) === undefined || localStorage.getItem(key) === null) {
            return false;
          }
          return JSON.parse(localStorage.getItem(key));
        },


        // Creates element only if not existing
        createIfNotExisting: function createIfNotExisting(key, value) {
          if (localStorage.getItem(key) === undefined || localStorage.getItem(key) === null) {
            return localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
          } else {
            return JSON.parse(localStorage.getItem(key));
          }
        },


        // retrieve an item from localStorage
        getItemOrDefault: function getItemOrDefault(key, defaultValue) {
          if (localStorage.getItem(key) === undefined || localStorage.getItem(key) === null) {
            return defaultValue;
          }

          return JSON.parse(localStorage.getItem(key));
        },


        // remove one item from localStorage
        removeItem: function removeItem(key) {
          // TODO: Should be named emptyItem
          return this.setItem(key, {});
        },


        // remove one item from localStorage
        clearItem: function clearItem(key) {
          return localStorage.removeItem(key); // this.setItem(key, {})
        },


        // remove all items from localStorage
        clear: function clear() {
          localStorage.clear();
        }
      }
    });
  }
};

if (window !== undefined && window.Vue) {
  window.Vue.use(store);
}

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "lEEI":
/***/ (function(module, exports) {

module.exports = {"current_context":"contextSupplierCoC","current_progress":"progressSupplierCoC","categories":[{"cat":"transport"},{"cat":"other"}]}

/***/ }),

/***/ "laZx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("EOym");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_110c6208_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("XyvV");
function injectStyle (ssrContext) {
  __webpack_require__("5XNs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_110c6208_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rSOv":
/***/ (function(module, exports) {

module.exports = {"currentLang":"no","videoID":"260227169","loader":"Oppdaterer","cat1":"transport","cat2":"other","menu":{"menu_titel":"Dine områder","ingress":"Her ser du de områdene som du kommer til å gå gjennom. Klikk på neste for å komme videre.","btn_move_on":"Neste","options":[{"opt1":{"link":"/case-lobby/case1","caseref":"case1","icon":"i-handshake","text":"Adferdskodeks"}},{"opt2":{"link":"/case-lobby/case2","caseref":"case2","icon":"i-leaf","text":"Miljøpåvirkning"}},{"opt3":{"link":"/case-lobby/case3","caseref":"case3","icon":"i-lorry","text":"Arbeidsvilkår"}},{"opt4":{"link":"/case-lobby/case4","caseref":"case4","icon":"i-thumbsup","text":"Forbedringsarbeid"}},{"opt5":{"link":"/case-lobby/case5","caseref":"case5","icon":"i-heart","text":"Bærekraftansvar"}}]},"instuctions":{"inst_1":{"header":"Instruksjoner","text":["Hvert område består av tre bilder, sveip til venstre for å bla. Fortsett så nedover for å svare på spørsmålene."]},"inst_2":{"header":"Instruksjoner","text":["Scroll ned for å svare på spørsmålene."]},"btn":"Lukk"},"menuoptions":{"mo1":"Introduksjon","mo2":"Sånn fungerer det","mo3":"Dine områder","mo4":"Slutt"},"home":{"title":"Velkommen!","video":"Begynn med å se på filmen","qu":"Spørsmål","sec1":{"p1":"Dette er PostNords opplæring om vår adferdskodeks for deg som leverandør og samarbeidspartner. Vårt mål er å sammen med dere skape en bærekraftig virksomhet som gir verdi for alle parter. Gjennom dialog, åpenhet og et aktivt samarbeid når vi målet.","p2":"Lykke til!"},"question":"Svar på spørsmålene for å tilpasse opplæringen til deg.","do_you":"Utfører din virksomhet landtransporter for PostNord?","yes":"Ja","no":"Nei"},"lobby":{"transport":"Transport","other":"Leverandør","button":"Start","title":"Sånn fungerer det","text":"Opplæringen går gjennom viktige områder som vår adferdskodeks for leverandører omhandler. Hvert område har et tilhørende spørsmål som du besvarer ut fra din virksomhet. Det er bare å sette i gang, vi veileder deg når det trengs."},"case_lobby":{"button":"Start"},"checklist":{"header":"Checklista","progress":"Du hade {0} rätt","p1":"Nu har du gått igenom alla dina situationer. Här finns en checklista med det viktigaste att tänka på för att du ska känna dig trygg med att du efterlever uppförandekoden.","p2":"","btn_save":"Ställ dessa frågor till dig själv:","btn_link":"Neste","list_part1":{"el1":"Vilka konsekvenser kan mitt agerande/icke-agerande få?","el2":"Stärker mitt agerande/icke-agerande förtroendet för PostNord?","el3":"Är mitt agerande/icke-agerande lagligt?","el4":"Är mitt agerande/icke-agerande förenligt med andan i Koden?"},"list_part2":{"el5":"Kan mitt agerande/icke-agerande påverkas av mitt personliga intresse eller någon annan intressekonflikt?","el6":"Håller mitt agerande/icke-agerande för en offentlig genomlysning?","el7":"Skyddar mitt agerande/icke-agerande PostNords rykte som en koncern som vill upprätthålla en hög affärsetik?"}},"done":{"header":"Takk!","text":"<p>Nå er du helt ferdig med opplæringen, takk for at du tok deg tid til å fullføre den.</p><p>Utviklingen innen bærekraft går fort. Hva blir neste steg i deres bærekraftsarbeid? Vi ser fram til å fortsette dialogen med dere rundt disse spørsmålene.</p><p>Har du spørsmål eller kommentarer, kan du kontakte oss på <a href=\"mailto:sustainablesupplychain@postnord.com.\">sustainablesupplychain@postnord.com</a></p><p>Les hele adferdskodeksen <a target=\"_blank\" href=\"https://www.postnord.com/en/sustainability/responsible-procurement/\">her.</a></p><p>Sammen skaper vi en mer bærekraftig framtid.</p>","button":"Avslutt"},"case_shared":{"lobby_button":"Start","case_info_show":"Hva sier kodeksen?","case_info_hide":"Klikk her for å lukke","case_info_icon":"i-i","case_qu_icon":"i-i","case_qu_question":"Spørsmål","case_qu_question1":"Spørsmål 1/2","case_qu_question2":"Spørsmål 2/2","case_qu_what":"Hva gjør du?","case_qu_feedback":"Tilbakemelding","case_qu_done":"Klar","case_next_question":"Neste","case_next":"Til neste område","all_cases_done":"Til avsluttende side","case_correct":"Det var riktig","case_wrong":"Det var dessverre feil"},"case5":{"lobby_header":"Å ta bærekraftsansvar i leverandørleddet","lobby_desc":"Sammen med våre leverandører inngår vi ofte i en lang og kompleks leverandørkjede, der vi har et felles ansvar for å levere på en bærekraftig måte.","case_qu_what1":"Hvor langt strekker bærekraftsansvaret seg?","icon":"i-white-heart","parts":{"part1":{"img":"case_1_1","text_header":"Kjøp","text":"En kunde kjøper en vare som skal leveres av PostNord."},"part2":{"img":"case_1_2","text_header":"Distribusjon","text":"PostNord kontakter leverandører, som bemanningsforetak på terminal og transportører for å distribuere varen."},"part3":{"img":"case_1_3","text_header":"Utkjøring","text":"Leverandøren kontakter i sin tur underleverandører til for eksempel utkjøring til kunden."}},"info":{"header":"Fra: PostNords adferdskodeks for leverandører","text":{"p1":"PostNords målsetting er å være ledende innen bærekraft i bransjen. Det krever at vi, sammen med våre leverandører, tar hensyn til og ansvar for den økonomiske, miljømessige og sosiale påvirkningen våre aktiviteter har på omverdenen. (§1.0)","p2":"For PostNord handler ansvarsfulle innkjøp av varer og tjenester om at vi sammen med våre samarbeidspartnere reduserer negativ påvirkning på miljøet, forebygger korrupsjon og bestikkelser samt bidrar til gode arbeidsvilkår for de ansatte. Slik skapes verdi, både for egen virksomhet, de ansatte, kunder, leverandører og samfunnet for øvrig.","p3":"Det er leverandørens ansvar å påse at underleverandører oppfyller kravene i leverandørkodeksen. Det er også leverandørens ansvar å vurdere og kontrollere sin leverandørkjede og på anmodning gi informasjon om dette til PostNord. (§8.0)"}},"qu1":{"answer1":"Til egen virksomhet.","answer2":"Til egen og underleverandørers virksomhet.","answer3":"Det omfatter alle steg i leverandørkjeden."},"feedback_1":{"p1":"I dag forventes foretak å ha kontroll på sin leverandørkjede, det holder ikke å ta ansvar bare for egen virksomhet. Det kan få negative konsekvenser for forretningene om det viser seg at dere eller deres underleverandører har dårlige ansettelsesvilkår, begår miljølovbrudd eller om forretningene er uetiske. God forretningsetikk, et bra arbeidsmiljø med gode vilkår samt å fatte miljøriktige beslutninger er noe som alle vinner på til slutt."}},"case1":{"lobby_header":"Å akseptere og følge PostNords adferdskodeks for leverandører ","lobby_desc":"Adferdskodeksen er mer enn en rekke punkter som godkjennes i begynnelsen av et samarbeid. Det er en forpliktelse å etterleve kravene, både i egen virksomhet og hos underleverandører.","case_qu_what1":"Hva trenger dere å gjøre som neste steg for å følge PostNords adferdskodeks for leverandører?","icon":"i-white-handshake","parts":{"part1":{"img":"case_2_1","text_header":"Krav","text":"Din virksomhet går med på kravene i adferdskodeksen når dere inngår avtale med PostNord."},"part2":{"img":"case_2_2","text_header":"Nåværende situasjon","text":"Dere går regelmessig gjennom hva dere behøver å gjøre for å oppfylle kravene."},"part3":{"img":"case_2_3","text_header":"Stadige forbedringer","text":"Gjennom å arbeide med stadige forbedringer innen områdene i adferdskodeksen skaper dere verdi for virksomheten. - Det kan være forskjell på hvor langt leverandører har kommet i sitt arbeid med å implementere adferdskodeksen. "}},"info":{"header":"Fra: PostNords adferdskodeks for leverandører","text":{"p1":"Leverandørkodeksen gjenspeiler PostNordkonsernets engasjement i forhold til FNs Global Compact, OECDs retningslinjer for multinasjonale selskaper og FNs veiledende prinsipper for bedrifter og menneskerettigheter. (§3.0)","p2":"PostNords leverandører skal respektere kravene i PostNords atferdskodeks for leverandører av landtransport (nedenfor kalt leverandørkodeksen) og arbeide proaktivt for å oppfylle dem, både i sin egen organisasjon og i leverandørkjeden. Dette bør skje gjennom dialog, åpenhet og et aktivt samarbeid mellom PostNord og leverandøren. (§1.0)"}},"qu1":{"answer1":"Kartlegge hvordan virksomheten følger adferdskodeksen i dag.","answer2":"Arbeide med de områdene som trenger forbedring.","answer3":"Kommunisere og følge opp kravene til underleverandører."},"feedback_1":{"p1":"Adferdskodeksen gjenspeiler PostNord-konsernets engasjement i forhold til bl.a. FNs Global Compact, OECDs retningslinjer for multinasjonale foretak og FNs veiledende prinsipper for bedrifter og menneskerettigheter.","p2":"PostNords leverandører skal overholde adferdskodeksen og gjøre sitt ytterste for å oppfylle kravene i egen organisasjon og i leverandørkjeden. Dette bør skje gjennom dialog, transparens og et åpent samarbeid mellom PostNord og leverandøren, noe som gagner begge parter. (§1.0)"}},"case4":{"lobby_header":"Å bedrive forbedringsarbeid","lobby_desc":"PostNords adferdskodeks for leverandører innebærer muligheter til et verdiskapende forbedringsarbeid.","case_qu_what1":"PostNord følger regelmessig opp arbeidet med adferdskodeksen for leverandører. Hva kan skje om et avvik oppdages?","icon":"i-white-thumbsup","parts":{"part1":{"img":"case_3_1","text_header":"Et identifisert avvik","text":"Dere oppdager et avvik, for eksempel at deres ansatte trenger å arbeide mye overtid for å rekke alt. Dere innleder en undersøkelse rundt hvorfor det har blitt slik."},"part2":{"img":"case_3_2","text_header":"Ha en dialog","text":"Dere diskuterer internt hva som må gjøres. Hvorfor oppstår overtiden? Hva kreves for at det skal skje en forandring? Kanskje trenger dere også å ha en dialog med andre aktører rundt hvordan oppdraget er utformet?"},"part3":{"img":"case_3_3","text_header":"Gjennomfør forandring","text":"Dere kontakter de som berøres, og informerer om nye rutiner. Det kan trenges regelmessig oppfølging for å sikre at forandringen gjennomføres og vedvarer."}},"info":{"header":"Fra: PostNords adferdskodeks for leverandører","text":{"p1":"”Vi oppmuntrer leverandørene til kontinuerlige forbedringer og til å arbeide med ledelsessystemer og standarder på de områdene som beskrives i leverandørkodeksen. Leverandørene bør også ha et system for hendelseshåndtering for å ta hånd om og forebygge hendelser.” (§2.0)","p2":"Forretningsrelasjonen mellom PostNord og leverandørene skal være basert på ærlighet, tillit og samarbeid. PostNord skal gis mulighet til å kontrollere leverandørenes overholdelse av kravene i leverandørkodeksen. Kontroller kan skje gjennom egenvurderinger og/eller ved at PostNords personale eller en tredjepart som PostNord har utpekt eller godkjent, gjennomfører revisjoner på stedet.","p3":"Avvik som eventuelt blir oppdaget under revisjoner, skal korrigeres innen avtalt tid. Hvis egenvurdering ikke gjennomføres innen den fastsatte tiden, kan PostNord kreve at leverandøren bekoster og legger frem en revisjonsrapport, gjennomført av en tredjepart som PostNord har utpekt eller godkjent, og som viser overholdelse av kravene i leverandørkodeksen.","p4":"Eventuelle revisjoner eller kontroller utført av PostNord hos leverandørers underleverandører, gjennomføres etter avtale med leverandøren. Unnlatelse å samarbeide for at PostNord skal kunne kontrollere overholdelse av leverandørkodeksen, eller å utbedre avdekkede mangler innen avtalt tid anses som et vesentlig avtalebrudd. (§8.0)"}},"qu1":{"answer1":"Avtalen med PostNord sies opp.","answer2":"Vi starter et samarbeid for å finne en langsiktig løsning der dere blir ansvarlige for å gjøre noe med avviket.","answer3":"Tilliten mellom PostNord og deg som leverandør vil bli brutt."},"feedback_1":{"p1":"Ingen er perfekt. Først når et problem er identifisert er det mulig å finne en løsning. PostNord foretar løpende oppfølging, og for oss er det viktig at vi har en åpen dialog med våre leverandører. Skaper vi gode forutsetninger for at dere skal kunne følge våre krav? Skaper dere i deres tur et godt arbeidsmiljø for deres ansatte?","p2":"Gjennom kommunikasjon skaper vi forståelse og muligheter til forbedringer som gir verdi for alle. Om PostNord ikke ser en vilje til å gjøre noe med avvik, gir adferdskodeksen muligheten til å si opp avtalen."}},"case2":{"lobby_header":"Måter å arbeide med miljøpåvirkning på","lobby_desc":"Transport er den delen av PostNords virksomhet som forårsaker størst miljøpåvirkning. Her fins det også muligheter til store forbedringer. Vi må jobbe sammen med våre leverandører for å redusere vår påvirkning på miljøet.","case_qu_what1":"Innen hvilket område har deres virksomhet størst mulighet til å redusere miljøpåvirkningen?","icon":"i-white-leaf","parts":{"part1":{"img":"case_4_1","text_header":"Kjøretøy","text":"Innkjøp av kjøretøy med så høy euroklasse som mulig og drivstoffbesparende aerodynamisk tilbehør reduserer helseskadelige utslipp og klimapåvirkning."},"part2":{"img":"case_4_2","text_header":"Drivstoff","text":"Valg av drivstoff med høy fornybar andel og energieffektiv kjøring reduserer klimapåvirkningen."},"part3":{"img":"case_4_3","text_header":"Vedlikehold","text":"Unngå miljøfarlige produkter ved rengjøring og vedlikehold av kjøretøyet. Velg lettrullende dekk og ha alltid rett lufttrykk for å redusere klimapåvirkningen."}},"info":{"header":"Fra: PostNord Groups bærekraftskrav til leverandører av landtransport","text":{"p1":"Leverandøren skal vite hvilken negativ påvirkning deres forretningsvirksomhet har på miljøet, og arbeide aktivt for å redusere den. (§6.0)","p2":"Leverandøren skal ha rutiner for å avdekke og måle sin miljøpåvirkning. (§6.1)","p3":"Spesifikke krav fins for følgende områder:","p4":"• Plan for redusert utslipp av karbondioksid (§6.2)","p5":"• Motorer (§6.3)","p6":"• Drivstoff (§6.4)","p7":"• Dekk (§6.5)","p8":"• Energieffektiv kjøring (§6.6)","p9":"• Luftmotstand (§6.7)","p10":"• Vedlikehold (§6.8)","p11":"• Rapportering av miljødata (§6.9)"}},"qu1":{"answer1":"Ved innkjøp av kjøretøy med høy miljøklasse.","answer2":"Ved valg og anvendelse av drivstoff.","answer3":"Ved vedlikehold av kjøretøy."},"feedback_1":{"p1":"Det viktigste er å kjenne til virksomhetens største miljøpåvirkning, og begynne der. Innen transport er innkjøp av kjøretøy med bedre motorer og å prioritere fornybart drivstoff eksempler på vanlige tiltak som kommer høyt på listen. Både lovkrav og kundekrav, for eksempel de som stilles til PostNord eller som PostNord stiller til leverandører, skjerpes hele tiden. Derfor er det viktig for deg som leverandør å oppfylle kravene som gjelder i dag, og å ha kontroll på og ha en plan for kommende krav. Har dere tenkt gjennom hva i deres virksomhet som har størst miljøpåvirkning? Arbeider dere med de tiltakene som gjør mest nytte?"}},"case3":{"lobby_header":"Måter å tilby gode arbeidsvilkår på","lobby_desc":"Sjåfører som kjører på oppdrag fra PostNord, er sentrale for at våre kunder skal få sine leveranser. De er vårt ansikt utad, og det er viktig at alle har gode arbeidsvilkår og forutsetninger for å gjøre en bra jobb.","case_qu_what1":"Innen hvilket område har deres virksomhet størst mulighet for å forbedre sjåførenes arbeidssituasjon?","icon":"i-white-lorry","parts":{"part1":{"img":"case_5_1","text_header":"Utdanning og kompetanse","text":"At sjåførene har yrkesrelevant utdanning og kunnskap om risikoer og krav til sikkerhet samt kunnskap om alkohol- og narkotikapolicy."},"part2":{"img":"case_5_2","text_header":"Arbeidsvilkår og arbeidsmiljø","text":"At sjåførene har en lovlig kontrakt med vilkår for å kunne utføre sitt arbeid på en trafikksikker måte med respekt for kjøre- og hviletider. Å ha mulighet til å ta hånd om seg selv og sin personlige hygiene under og mellom sine arbeidsskift."},"part3":{"img":"case_5_3","text_header":"Lønn og godtgjørelse","text":"At sjåførene får en rimelig lønn for utført arbeid, mottar lovmessige kostpenger og godtgjørelser. At sjåførene har lønnsvilkår som ikke setter trafikksikkerheten i fare."}},"info":{"header":"Fra: PostNord Groups bærekraftskrav til leverandører av landtransport","text":{"p1":"Leverandøren skal kjenne til og respektere allment anerkjente globale menneskerettigheter og praktisere rettferdige arbeidsvilkår. (§4.0)","p2":"Leverandøren skal fremme et godt arbeidsmiljø og forebygge risiko for fysisk og psykisk sykdom på grunn av organisatoriske og sosiale forhold i arbeidsmiljøet. (§5.0)","p3":"Spesifikke krav fins for følgende områder:","p4":"• Likebehandling (§4.1)","p5":"• Akseptabel lønn og godtgjørelse (§4.2)","p6":"• Rimelige arbeidstider, hviletider og ferier (§4.3)","p7":"• Arbeidsavtale (§4.4)","p8":"• Foreningsfrihet og rett til å forhandle kollektivt (§4.5)","p9":"• Frihet og mobilitet på arbeidsmarkedet (§4.6)","p10":"• Nulltoleranse mot barnearbeid (§4.7)","p11":"• Systematisk arbeidsmiljøarbeid (§5.1)","p12":"• Opplæring og sikkerhet (§5.2)","p13":"• Nulltoleranse mot alkohol og rus midler (§5.3)","p14":"• Sikker parkering og fasiliteter (§5.4)"}},"qu1":{"answer1":"Utdanning og kompetanse.","answer2":"Arbeidsvilkår og arbeidsmiljø.","answer3":"Lønn og godtgjørelse. "},"feedback_1":{"p1":"Det er ditt ansvar som arbeidsgiver å sikre gode arbeidsvilkår. Tenk gjennom hva dere gjør for å skape rette forutsetninger for deres ansatte. Om de ansatte har rett kompetanse, trives og er fornøyde med sitt arbeid og får en rimelig lønn, er sannsynligheten større for at de blir værende og fortsetter å gjøre en bra jobb, samtidig som de kjører sikkert og leverer god kvalitet. Det vinner virksomheten på."}}}

/***/ }),

/***/ "rY+s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("HJxK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07bb9c60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Zgsm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07bb9c60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rhSk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("FA5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_163de244_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("v+IX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_163de244_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v+IX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"touch",rawName:"v-touch:tap",value:(_vm.categoryItemClicked),expression:"categoryItemClicked",arg:"tap"}],staticClass:"menu-option-wrapper pure-u-1-1"},[(_vm.isbutton)?_c('router-link',{staticClass:"router-link-active",attrs:{"to":{ path: _vm.values.link, props: { caseref: _vm.values }}}},[_c('div',{staticClass:"menu-option isbutton pure-g"},[_c('div',{staticClass:"menu-icon pure-u-1-5"},[_c('div',{class:['option-icon', _vm.getIconClass]})]),_vm._v(" "),_c('div',{class:['text', 'center', {'pure-u-3-5': _vm.hasCheck, 'pure-u-4-5': !_vm.hasCheck}]},[_c('p',[_vm._v(_vm._s(_vm.values.text))])]),_vm._v(" "),(_vm.hasCheck)?_c('div',{staticClass:"check pure-u-1-5"},[_c('div',{class:['checkbox', {'checked': _vm.values.checked}]})]):_vm._e()])]):(!_vm.isbutton)?_c('div',{staticClass:"menu-option pure-g"},[_c('div',{staticClass:"menu-icon pure-u-1-5"},[_c('div',{class:['option-icon', _vm.getIconClass]})]),_vm._v(" "),_c('div',{staticClass:"text center pure-u-3-5"},[_c('p',[_vm._v(_vm._s(_vm.values.text))])]),_vm._v(" "),(_vm.hasCheck)?_c('div',{staticClass:"check pure-u-1-5"},[_c('div',{class:['checkbox', {'checked': _vm.values.checked}]})]):_vm._e()]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showLoader: false,
      timeout: null
    };
  },
  mounted: function mounted() {
    var self = this;

    self.$bus.$on('LOADER.SHOW', function () {
      self.showLoader = true;
      self.timeout = setTimeout(function () {
        self.showLoader = false;
      }, 10000);
    });

    self.$bus.$on('LOADER.HIDE', function () {
      if (self.timeout !== null) {
        clearTimeout(self.timeout);
      }
      setTimeout(function () {
        self.showLoader = false;
      }, 200); // TODO: En timeout här bara för att testa!!!!!
    });
  },

  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b4e5223e0dfabd471caa.js